import React, { useState, useEffect, useRef } from 'react'
import { Breadcrumb, BreadcrumbItem, Modal, FileUploader, FileUploaderItem, Button, Dropdown, TextArea, InlineNotification } from 'carbon-components-react';
import { TagComponent } from 'common/TagComponent';
import { Attachment16, Chat32 } from '@carbon/icons-react';
import * as Constants from '../../../requests/URLConstants';
import callPostApi from "../../../requests/PostRequests";
import * as IncidentDetailsConstants from './IncidentDetailsConstants';
import IncidentDetailsCollaboration from './IncidentDetailsCollaboration';
import * as config from "../../../config/Constants"
import * as workspaces from '../../../config/WorkspaceConstants'

const IncidentDetailsHeaderPanel = (props) => {
    const [updatedIncident, setUpdatedIncident] = useState({});
    const [showAttachmentModal, setShowAttachmentModal] = useState(false);
    const [fileUploadLoading, setFileUploadLoading] = useState(false);
    const [fileUploadSuccess, setFileUploadSuccess] = useState(false);
    const [fileUploadStatus, setFileUploadStatus] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [uploadedFile, setUploadedFile] = useState();
    const [fileInputKey, setFileInputKey] = useState();
    const [showCollaborationModal, setShowCollaborationModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [reasonToUpdate, setReasonToUpdate] = useState('');
    //const [UpgradeDowngradeError, setUpgradeDowngradeError] = useState(false);
    let statusChange = useRef(false);
    let statusInputChange = useRef({});

    useEffect(() => {
        if (props.incidentDetailsData && props.stateList) {
            setUpdatedIncident(props.incidentDetailsData);
        }
    }, [props.incidentDetailsData, props.stateList]);

    useEffect(() => {
        //useffect to disable inline error when valid dropdown selection is made
        if (props.UpgradeDowngrade === "Downgrade" && (props.incidentDetailsData && props.incidentDetailsData.reasonsToDowngrade && props.incidentDetailsData.reasonsToDowngrade.label.length > 0)) {
            props.handleReasonDropdownError(false);
        }
        else if (props.UpgradeDowngrade === "Upgrade" && (props.incidentDetailsData && props.incidentDetailsData.reasonsToUpgrade && props.incidentDetailsData.reasonsToUpgrade.label.length > 0)) {
            props.handleReasonDropdownError(false);
        }
    }, [props.UpgradeDowngrade, props.incidentDetailsData.reasonsToDowngrade, props.incidentDetailsData.reasonsToUpgrade]);

    useEffect(() => {
        let fileUploadStatus = 'edit';
        if (fileUploadLoading) {
            fileUploadStatus = 'uploading';
        }
        if (fileUploadSuccess) {
            fileUploadStatus = 'complete';
        }
        setFileUploadStatus(fileUploadStatus);
    }, [fileUploadLoading, fileUploadSuccess]);

    const toggleShowAttachmentModal = () => {
        setShowAttachmentModal(!showAttachmentModal);
        if (!showAttachmentModal) {
            setUploadedFile(null);
        }
    };

    const changeIncidentState = (e) => {
        // let changedState = {
        //     state: e.selectedItem
        // };
        statusInputChange.current = e.selectedItem;
        if (props.workspace === workspaces.custom_ops) {
            if (props.incidentDetailsData.assigned_to.label === '' && props.incidentDetailsData.assigned_to.id === '') {
                statusChange.current = true;
                props.statusChange(true);
            }
            else {
                statusChange.current = false;
                props.statusChange(false);
            }
        }
        let value = e.selectedItem ? e.selectedItem.label : '';
        let id = e.selectedItem ? e.selectedItem.id : '';
        // setUpdatedIncident({ ...updatedIncident, 'state': changedState.state });
        setUpdatedIncident({ ...updatedIncident, 'state': { 'label': value, 'id': id } });

    };

    const handleFileChanged = (e) => {
        var files = e.target.files;
        setSelectedFile(files);
    }

    const prepareUploadFilePayload = () => {
        let data = new FormData();
        for (var x = 0; x < selectedFile.length; x++) {
            data.append('file', selectedFile[x]);
        }
        data.append('sys_id', props.sysId);
        return data;
    };

    const uploadDocument = () => {
        if (selectedFile) {
            setFileUploadLoading(true);
            setFileUploadSuccess(false);
            let bodyJSON = prepareUploadFilePayload();
            callPostApi(Constants.UPLOADATTACHMENT + props.sysId, {
                'Content-Type': 'application/json'
            }, bodyJSON).then(response => {
                setFileInputKey(Date.now());
                if (response) {
                    setFileUploadSuccess(true);
                    setUploadedFile(selectedFile[0].name);
                    setSelectedFile(null);
                } else {
                    setFileUploadSuccess(false);
                }
                setFileUploadLoading(false);
            }).catch(error => {
                setFileUploadLoading(false);
            });
        }
    };

    const toggleCollaborationModal = () => {
        setShowCollaborationModal(!showCollaborationModal);
    };

    const goToResolutionTab = () => {
        var resolutionTab = document.getElementById("resolutionTab");
        resolutionTab.click();
        var resolveButton = document.getElementById("resolveIncidentButon");
        if (resolveButton) {
            resolveButton.scrollIntoView();
        } else {
            resolutionTab.scrollIntoView();
        }
    };

    let roles = JSON.parse(localStorage.getItem('roles'));
    const openInTicketingTool = () => {
        window.open(props.ticketingToolPath, "_blank");
    };


    const toggleCloseModal = () => {
        setShowUpdateModal(!showUpdateModal);
        setReasonToUpdate('');
    }

    const handleReasonChange = (e) => {
        let value = e.target.value && e.target.value.trim();
        setReasonToUpdate(value);
    }

    const handleShowUpdateModal = () => {
        if (props.incidentDetailsDataForCompare.state.label !== updatedIncident.state.label
            || props.incidentDetailsDataForCompare.contact_type.label !== props.incidentDetailsData.contact_type.label
            || props.incidentDetailsDataForCompare.assignment_group.label !== props.incidentDetailsData.assignment_group.label
            || props.incidentDetailsDataForCompare.assigned_to.label !== props.incidentDetailsData.assigned_to.label
            || props.incidentDetailsDataForCompare.category.label !== props.incidentDetailsData.category.label
            || props.incidentDetailsDataForCompare.subcategory.label !== props.incidentDetailsData.subcategory.label
            || props.incidentDetailsDataForCompare.resolvedBySOC.label !== props.incidentDetailsData.resolvedBySOC.label
            || props.incidentDetailsDataForCompare.actionTakenBySOC.label !== props.incidentDetailsData.actionTakenBySOC.label
            || props.incidentDetailsDataForCompare.impact.label !== props.incidentDetailsData.impact.label
            || props.incidentDetailsDataForCompare.urgency.label !== props.incidentDetailsData.urgency.label
        ) {
            //code to check upgrade or downgrade value is selected or not and set error accordingly
            if (props.UpgradeDowngrade === "Downgrade" && ((props.incidentDetailsData && props.incidentDetailsData.reasonsToDowngrade && props.incidentDetailsData.reasonsToDowngrade.label === "") || props.incidentDetailsData.reasonsToDowngrade === undefined)) {
                props.handleReasonDropdownError(true);
                setShowUpdateModal(false);
            }
            else if (props.UpgradeDowngrade === "Upgrade" && ((props.incidentDetailsData && props.incidentDetailsData.reasonsToUpgrade && props.incidentDetailsData.reasonsToUpgrade.label === "") || props.incidentDetailsData.reasonsToUpgrade === undefined)) {
                props.handleReasonDropdownError(true);
                setShowUpdateModal(false);
            }
            else {
                props.handleReasonDropdownError(false);
                setShowUpdateModal(true);
            }
        }
        else {
            setShowUpdateModal(false);
            props.updateIncident(updatedIncident);
            props.handleReason("");
        }
    }

    const updateReason = () => {
        //if there is Downgrade or Upgrade, then update modal should be disabled and error should be enabled until it is selected.
        if (props.UpgradeDowngrade === "Downgrade" && ((props.incidentDetailsData && props.incidentDetailsData.reasonsToDowngrade && props.incidentDetailsData.reasonsToDowngrade.label === "") || props.incidentDetailsData.reasonsToDowngrade === undefined)) {
            props.handleReasonDropdownError(true);
            setShowUpdateModal(false);
        }
        else if (props.UpgradeDowngrade === "Upgrade" && ((props.incidentDetailsData && props.incidentDetailsData.reasonsToUpgrade && props.incidentDetailsData.reasonsToUpgrade.label === "") || props.incidentDetailsData.reasonsToUpgrade === undefined)) {
            props.handleReasonDropdownError(true);
            setShowUpdateModal(false);
        }
        else {
            setShowUpdateModal(!showUpdateModal);
            props.handleReason(reasonToUpdate);
            props.updateIncident(updatedIncident);
        }
    }

    return (
        <div className="header-panel">
            <div>
                <Breadcrumb aria-label="Page navigation">
                    {props.workspace === workspaces.automation_ops || props.workspace === workspaces.sap_ops || props.workspace === workspaces.salesforce_ops ?
                        <BreadcrumbItem href='/homepage'>
                            {IncidentDetailsConstants.Home}
                        </BreadcrumbItem> : null}
                    <BreadcrumbItem href="/manage_operations">
                        {IncidentDetailsConstants.ManageOperations}
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div className="action-container">
                <div className="incident-info">
                    <div className="incident-number">
                        {props.incidentDetailsData.number}
                    </div>
                    <div className={"tags-container " + (!props.disableIncidentUpdate ? 'limited-width' : '')}>
                        {props.stateList.map((data, index) => {
                            return (
                                <TagComponent key={'tag' + index} type="blue" disabled={props.incidentDetailsData.state.label !== data.label} >
                                    {data.label}
                                </TagComponent>
                            )
                        })}
                    </div>
                </div>
                {!props.disableIncidentUpdate ?
                    <div className="action-controls">
                        <Button
                            className="buttonIcon"
                            hasIconOnly
                            tooltipAlignment="center"
                            tooltipPosition="bottom"
                            iconDescription={IncidentDetailsConstants.UploadFiles}
                            renderIcon={Attachment16}
                            kind='ghost'
                            disabled={props.disableIncidentUpdate}
                            onClick={toggleShowAttachmentModal}
                        />
                        <Dropdown
                            id="status"
                            className="incident-status-control"
                            label={IncidentDetailsConstants.ChangeStatus}
                            // items={IncidentDetailsConstants.incidentStatusItems}
                            items={props.stateList}
                            itemToString={(item) => (item ? item.label : '')}
                            selectedItem={props.workspace === workspaces.custom_ops ? Object.keys(statusInputChange.current).length > 0 ? statusInputChange.current : updatedIncident.state : updatedIncident.state}
                            onChange={(e) => changeIncidentState(e)}
                            disabled={props.disableIncidentUpdate}
                        />
                        <div className="button-container">
                            {config.URL.includes(config.unilever) ?
                                roles && roles.includes("Automation CoE") === true ? null
                                    : openInTicketingTool && <Button onClick={openInTicketingTool} size='small' kind='tertiary'>{IncidentDetailsConstants.OpenInTicketingTool}</Button>
                                :
                                openInTicketingTool &&
                                <Button onClick={openInTicketingTool} size='small' kind='tertiary'>{IncidentDetailsConstants.OpenInTicketingTool}</Button>
                            }
                            <Button size='small' kind='secondary' disabled={props.workspace === workspaces.custom_ops ? props.disableIncidentUpdate || props.assignedTo : props.disableIncidentUpdate} onClick={() => { props.workspace === workspaces.custom_ops ? handleShowUpdateModal() : props.updateIncident(updatedIncident); }}>{IncidentDetailsConstants.Update}</Button>
                            <Button size='small' disabled={props.disableIncidentUpdate} onClick={goToResolutionTab}>{IncidentDetailsConstants.Resolve}</Button>
                            <Button
                                className="buttonIcon"
                                hasIconOnly
                                tooltipAlignment="center"
                                tooltipPosition="bottom"
                                iconDescription={IncidentDetailsConstants.Collaboration}
                                renderIcon={Chat32}
                                kind='ghost'
                                disabled={props.disableIncidentUpdate}
                                onClick={toggleCollaborationModal}
                            />
                        </div>
                    </div>
                    :
                    config.URL.includes(config.unilever) ? roles && roles.includes("Automation CoE") === true ? null : openInTicketingTool && <Button onClick={openInTicketingTool} size='small'>{IncidentDetailsConstants.OpenInTicketingTool}</Button>
                        : openInTicketingTool && <Button onClick={openInTicketingTool} size='small'>{IncidentDetailsConstants.OpenInTicketingTool}</Button>
                }
            </div>
            <Modal
                open={showAttachmentModal}
                onRequestClose={toggleShowAttachmentModal}
                onRequestSubmit={uploadDocument}
                modalHeading={IncidentDetailsConstants.ChooseFiles}
                modalLabel={IncidentDetailsConstants.UploadFiles}
                primaryButtonText={IncidentDetailsConstants.UploadFiles}
                primaryButtonDisabled={fileUploadLoading}
                secondaryButtonText={IncidentDetailsConstants.Cancel}
            >
                <p>{IncidentDetailsConstants.Maxfile}</p>
                <div className="bx--file__container">
                    {<FileUploader
                        accept={[]}
                        buttonKind="primary"
                        filenameStatus={fileUploadStatus}
                        buttonLabel={IncidentDetailsConstants.Addfiles}
                        iconDescription={IncidentDetailsConstants.Clearfile}
                        onChange={e => handleFileChanged(e)}
                        key={fileInputKey}
                    />}
                    {uploadedFile &&
                        <FileUploaderItem
                            name={uploadedFile}
                            status={fileUploadStatus}
                        />
                    }
                </div>
            </Modal>
            <IncidentDetailsCollaboration incidentDetailsData={props.incidentDetailsData} showCollaborationModal={showCollaborationModal}
                toggleCollaborationModal={toggleCollaborationModal}
            />
            {
                showUpdateModal && props.workspace === workspaces.custom_ops &&
                <Modal
                    className='update-modal'
                    primaryButtonText={IncidentDetailsConstants.Update}
                    open={showUpdateModal}
                    primaryButtonDisabled={reasonToUpdate.length > 0 ? false : true}
                    onRequestClose={toggleCloseModal}
                    onRequestSubmit={updateReason}
                    preventCloseOnClickOutside={true}
                >
                    <div className="update-reason">
                        {/* <div className="text-count carbon-display-Regular-14">{count}/500</div> */}
                        <TextArea
                            id="update-text"
                            className="carbon-display-Regular-14 updateText"
                            labelText={IncidentDetailsConstants.PleaseProvideReason}
                            maxCount={400}
                            rows={4}
                            enableCounter={true}
                            placeholder={IncidentDetailsConstants.PleaseProvideReason}
                            onChange={handleReasonChange}
                        />
                        {/* <Button className="margin-left-10px post-button" style={{ marginTop: '20px' }} onClick={updateReason} disabled={reasonToUpdate.length > 0 ? false : true}>{IncidentDetailsConstants.Update}</Button> */}
                    </div>
                </Modal>
            }
        </div>
    );
};

export default IncidentDetailsHeaderPanel;